import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 25px;
  text-align: center;
  width: 100%;
`;
